import { forwardRef } from 'react';
import type { SVGIconProps } from '../types';
export const NoLogoIcon = forwardRef<SVGSVGElement, SVGIconProps>(({
  color = 'currentColor',
  size = 16,
  ...props
}, ref) => <svg ref={ref} width={size} height={size} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <g id="NoLogo">
        <path id="Vector" d="M15.1627 4.8216C19.478 8.70714 19.5639 10.3473 15.6784 14.6627C11.7929 18.978 10.1527 19.0639 5.83734 15.1784C1.52201 11.2929 1.43605 9.65268 5.3216 5.33734C9.20714 1.02201 10.8473 0.936051 15.1627 4.8216Z" fill={color} />
      </g>
    </svg>);
NoLogoIcon.displayName = 'NoLogoIcon';